import nprogress from 'nprogress';

const attachedInstances = new WeakSet();

/**
 * Replaces axios-progress-bar for axios 1.x: same UX (NProgress start on request, done when idle),
 * ref-counted across concurrent calls. save/submit/get* on ShareOfAccountsApi all use this instance.
 */
export function attachAxiosNProgress(instance) {
  if (!instance || attachedInstances.has(instance)) {
    return instance;
  }
  attachedInstances.add(instance);

  let active = 0;

  instance.interceptors.request.use((config) => {
    active += 1;
    nprogress.start();
    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      active = Math.max(0, active - 1);
      if (active === 0) {
        nprogress.done();
      }
      return response;
    },
    (error) => {
      active = Math.max(0, active - 1);
      if (active === 0) {
        nprogress.done();
      }
      return Promise.reject(error);
    }
  );

  return instance;
}
